import BlogArticleSwiper from "@/components/BlogArticle/BlogArticleSwiper";
import BlogArticleInfo from "@/components/BlogArticle/BlogArticleInfo";
import BlogArticleBanner from "@/components/BlogArticle/BlogArticleBanner";
import SEO from "@/components/SEO";
import Collection from "@sourceflow-uk/sourceflow-sdk/collection";
import localizePath from "@/functions/localizePath";
import BlogContentJoin from "@/components/Shared/BlogContentJoin";

export default function BlogArticlePage({ locale = "en", page, blogs }) {
  return (
    <>
      <SEO
        path={localizePath(`/newsroom/${page.url_slug}`, locale)}
        title={`${page?.title} | Blog | Lawrence Harvey`}
        description={page?.description}
        image={page?.image}
      />
      <main className="bg-white h-full sm:pt-[160px]">
        <BlogArticleBanner article={page} />
        <BlogArticleInfo article={page} />
        <BlogArticleSwiper blogs={blogs} color="purple" />
        <div className="py-[85px] container">
          <BlogContentJoin
            content={{
              title: "Looking for your next role in technology?",
              info: ` We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve refined ou. We’ve been helping clients achieve the results they need for over 20 years. In that time, we’ve.`,
            }}
            path="newsroom"
          />
        </div>
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const blogs = (await Collection("blogs")).getItems();
  const page = blogs.find((i) => i.url_slug === url_slug);

  return {
    props: {
      page,
      blogs: blogs.slice(0, 3),
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: (await Collection("blogs")).getPaths("url_slug"),
    fallback: false,
  };
}
